/**
 * Collab pointer reporter (Collab Phase 10). Verbatim slice embedded inside the
 * iframe bridge IIFE (NOT module code) — interpolation-free. Streams the local
 * user's pointer as document-relative coordinates (clientY + scrollY, so it is
 * zoom/scroll-independent) at a 40 ms trailing throttle, null on pointerleave.
 * Enabled only after the parent sends `set-collab-active` (message-handler
 * flips `_collabReportActive`), so solo sessions never post pointer traffic.
 */

export function collabReporterLayer() {
  return String.raw`  // --- Collab: pointer reporter (Phase 10) ---
  var _collabReportActive = false;    // flipped by message-handler on set-collab-active
  var _collabPointerTimer = null;
  var _collabPointerPending = null;

  window.__pbSetCollabReportActive = function (on) {
    _collabReportActive = !!on;
    if (!_collabReportActive) {
      if (_collabPointerTimer) { clearTimeout(_collabPointerTimer); _collabPointerTimer = null; }
      _collabPointerPending = null;
    }
  };

  function _flushCollabPointer() {
    _collabPointerTimer = null;
    if (!_collabReportActive) return;
    if (_collabPointerPending === null) { send('collab-pointer', null); return; }
    send('collab-pointer', _collabPointerPending);
  }

  function _scheduleCollabPointer() {
    if (_collabPointerTimer) return; // trailing throttle: one send per window
    _collabPointerTimer = setTimeout(_flushCollabPointer, 40);
  }

  document.addEventListener('pointermove', function (e) {
    if (!_collabReportActive) return;
    _collabPointerPending = { x: e.clientX, y: e.clientY + window.scrollY };
    _scheduleCollabPointer();
  }, { passive: true });

  document.addEventListener('pointerleave', function () {
    if (!_collabReportActive) return;
    _collabPointerPending = null;
    _scheduleCollabPointer();
  }, { passive: true });

`;
}
